var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "mr-t-10" }, [
        _c("p", { staticClass: "discription text-size-20" }, [
          _vm._v("ACROSS倉庫商品の受取金額差額を設定できます")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "discription" }, [
          _vm._v("「Amazon倉庫の受取金額」に対する差額をご設定ください。")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "discription" }, [
          _vm._v("すでに出品登録済み商品の受取金額には影響しません。")
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "mr-t-20",
            attrs: { "data-vv-scope": "setting-form" }
          },
          [
            _c(
              "fieldset",
              {
                staticClass:
                  "border bg-light-soft flex flex-flow-column gap-10 pd-t-10"
              },
              [
                _c("div", {}, [
                  _vm._v("Amazon倉庫の受取金額からの減額費用をご入力ください")
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex flex-content-center label-width-3 gap-10"
                  },
                  [
                    _c("input-money", {
                      staticClass: "custom-border",
                      attrs: {
                        validation: "required|moneyMin:0|numberLength:6",
                        label: "受取金額差額",
                        allowNegative: false
                      },
                      on: { input: _vm.handleInputOfferPriceAcrossDiff },
                      model: {
                        value: _vm.offerPriceAcrossDiff,
                        callback: function($$v) {
                          _vm.offerPriceAcrossDiff = $$v
                        },
                        expression: "offerPriceAcrossDiff"
                      }
                    }),
                    _vm._v("円\n          ")
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "fieldset",
              {
                staticClass:
                  "border bg-light-soft flex flex-flow-column gap-10 "
              },
              [
                _c("div", {}, [
                  _c("p", [_vm._v("受取金額のシミュレーション")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-content-center gap-15",
                      staticStyle: { "justify-content": "flex-start" }
                    },
                    [
                      _c("span", [_vm._v("Amazon倉庫の受取金額が")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-content-center gap-10" },
                        [
                          _c("input-money", {
                            staticClass: "custom-border",
                            attrs: {
                              validation: "required|moneyMin:1|numberLength:6",
                              label: "Amazon倉庫の受取金額が",
                              allowNegative: false
                            },
                            on: { input: _vm.handlerInputAmazonAmountReceived },
                            model: {
                              value: _vm.amazonAmountReceived,
                              callback: function($$v) {
                                _vm.amazonAmountReceived = $$v
                              },
                              expression: "amazonAmountReceived"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "label-width-3" }, [
                            _vm._v("円 の場合")
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-content-center gap-15 mr-t-15",
                      staticStyle: { "justify-content": "left" }
                    },
                    [
                      _c("div", { staticClass: "w-200" }, [
                        _c("br"),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-right bg-white pd-t-10 pd-b-10 pd-l-10 pd-r-10"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-content-center",
                                staticStyle: {
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30",
                                  attrs: { src: _vm.amazonIconUrl, alt: "#" }
                                }),
                                _vm._v(
                                  "\n                    ¥\n                    "
                                ),
                                _c("input", {
                                  staticClass:
                                    "form-control text-right bd-rds-8 w-120",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: {
                                    value: _vm.formatAmount(
                                      _vm.amazonAmountReceived
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-price text-price-number" },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.expectedAmount(
                                        _vm.amazonAmountReceived
                                      )
                                    )
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-caret-right text-red text-size-45",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c("span", { staticClass: "text-danger text-right" }, [
                          _vm._v("ACROSS倉庫の受取金額をご確認ください")
                        ]),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-right w-200 bg-white pd-t-10 pd-b-10 pd-l-10 pd-r-10"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-content-center",
                                staticStyle: {
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30",
                                  attrs: { src: _vm.salmonIconUrl, alt: "#" }
                                }),
                                _vm._v(
                                  "\n                    ¥\n                    "
                                ),
                                _c("input", {
                                  staticClass:
                                    "form-control text-right bd-rds-8 w-120",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: {
                                    value: _vm.formatAmount(
                                      _vm.salmonAmountReceived
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-price text-price-number" },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.expectedAmount(
                                        _vm.salmonAmountReceived
                                      )
                                    )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mr-t-20" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-warning w-120 check-maintenance",
                  attrs: { type: "button", disabled: _vm.disabled },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.updateSetting()
                    }
                  }
                },
                [
                  _vm._v("\n            更新\n            "),
                  _c("i", {
                    staticClass: "fa fa-check text-size-16",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass:
          "control-label flex-lable label-width-3 pd-t-5 pd-b-5 pd-l-10"
      },
      [
        _vm._v("受取金額差額\n            "),
        _c("span", { staticClass: "text-danger m-r-sm" }, [_vm._v("＊")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "text-right bg-primary pd-t-5 pd-b-5 pd-r-10" },
      [
        _vm._v("\n                  受取金額(税込) "),
        _c("br"),
        _vm._v("\n                  予想出品金額(税込)\n                ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "text-right bg-primary pd-t-5 pd-b-5 pd-r-10 w-200" },
      [
        _vm._v("\n                  受取金額(税込) "),
        _c("br"),
        _vm._v("\n                  予想出品金額(税込)\n                ")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-674e56cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674e56cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/SettingAcrossPriceDiff.vue
// module id = null
// module chunks = 